import React from 'react'
import { Navbar, Container, Row, Col } from 'react-bootstrap'
import Image from 'react-bootstrap/Image';

const Header = () => {
  return (
    <>
      <Navbar bg='dark' variant='dark'>
        <Container>
          <Row>
            <Col>
              <Navbar.Brand href="/">
                <Image src="https://library.sru.ac.th/wp-content/uploads/sites/29/2022/12/cropped-SRU-LOGO-50th-1.png" rounded width={65} />
                หอสมุด มหาวิทยาลัยราชภัฏสุราษฎร์ธานี
              </Navbar.Brand>
            </Col>
          </Row>
        </Container>
      </Navbar>
      {/* <Navbar bg="dark" variant="dark">
        <Container>
          <Navbar.Brand href="#home">
            <img
              alt=""
              src="https://library.sru.ac.th/wp-content/uploads/sites/29/2022/12/cropped-SRU-LOGO-50th-1.png"
              width="30"
              height="30"
              className="d-inline-block align-top"
            />{' '}
            ตรวจสอบการยืมเกินกำหนดส่งคืนทรัพยากร
          </Navbar.Brand>
        </Container>
      </Navbar> */}
    </>
  )
}

export default Header